import { cn } from '@/lib/utils'

interface ImportStepperProps {
  steps: readonly { key: string; label: string }[]
  /** The key of the step the user is on. */
  current: string
}

/**
 * The steps of an import wizard (shared by the lead import, spec-60 B2, and the CRM
 * import, spec-63 E6): the current step is marked, earlier ones are done.
 */
export function ImportStepper({ steps, current }: ImportStepperProps) {
  const currentIndex = steps.findIndex((item) => item.key === current)
  return (
    <ol className="flex flex-wrap gap-2" aria-label="Stappen">
      {steps.map((item, index) => (
        <li
          key={item.key}
          aria-current={index === currentIndex ? 'step' : undefined}
          className={cn(
            'rounded-full px-3 py-1 text-sm font-semibold',
            index === currentIndex
              ? 'bg-primary text-primary-foreground'
              : index < currentIndex
                ? 'bg-muted text-foreground'
                : 'bg-white text-muted-foreground',
          )}
        >
          {item.label}
        </li>
      ))}
    </ol>
  )
}
